import React from 'react';
import { useLazyQuery, gql } from "@apollo/client";
import { fragments as shipmentFragments } from "/imports/api/shipments/apollo/fragments";
import { Loader } from "semantic-ui-react";
import { ShipmentType } from '/imports/api/shipments/interfaces/Shipment';


const GET_SHIPMENT_INFO = gql`
  query getShipmentInfoForTag($shipmentId: String!) {
    shipment: getShipmentInfo(shipmentId: $shipmentId) {
      id
      number
      ...shipmentReferences
    }
  }
  ${shipmentFragments.shipmentReferences}
`

type IShipmentInfo = Pick<ShipmentType, "number" | "references">

interface IShipmentTagProps extends IShipmentInfo {
  shipmentId: string;

}
const ShipmentTag = ({ number, references }: IShipmentTagProps) => {
  return references?.number ? (<>
    {references.number}
    <span style={{ opacity: 0.5 }}> — {number}</span>
  </>
  ) : (
    <>{number}</>
  );
}

interface IShipmentTagLoaderProps {
  shipmentId: string;
  shipment?: IShipmentInfo
}
const ShipmentTagLoader = ({ shipmentId, shipment }: IShipmentTagLoaderProps) => {
  const [getShipmentInfo, { data = {}, loading, called }] = useLazyQuery(GET_SHIPMENT_INFO, {
    variables: { shipmentId }
  });

  if ((!shipment?.number && !!shipmentId) && !called) getShipmentInfo();

  return loading ? (
    <Loader active inline />
  ) : (
    <ShipmentTag
      shipmentId={shipmentId}
      number={shipment?.number || data?.shipment?.number}
      references={shipment?.references || data?.shipment?.references}
    />)
}
export default ShipmentTagLoader;